import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { QBox, QButton, QStack, QText } from '@captivateiq/quotient';

import assistantI18n from '@captivateiq/assistant/i18n';

import { useAIShellContext } from '@captivateiq/assistant/AIShellContext';
import { getAgentConfig } from '@captivateiq/assistant/config/agentConfig';
import { SamplePromptCard } from './SamplePromptCard';
import { TabLayout } from '../../TabLayout';
import { AgentIntroduction } from '../shared/AgentIntroduction';
import { MessageInput } from '../shared/MessageInput';

export const IntroView = () => {
  const { t } = useTranslation('assistant', { i18n: assistantI18n });
  const { selectedAgent, backToAgentBrowser, openChatAndSend } = useAIShellContext();

  const handleSubmit = useCallback(
    async (message: string) => {
      await openChatAndSend(message);
    },
    [openChatAndSend],
  );

  const prompts = useMemo(() => {
    if (!selectedAgent) return [];
    const config = getAgentConfig(selectedAgent, t);
    return config.prompts;
  }, [selectedAgent, t]);

  return (
    <TabLayout bottomContent={<MessageInput onSubmit={handleSubmit} />}>
      <AgentIntroduction agentName={selectedAgent ?? ''} />
      <QStack
        direction="column"
        spacing="10px"
        sx={{
          alignItems: 'stretch',
          backgroundColor: 'grey.50',
          flex: 1,
          padding: '16px',
        }}
      >
        {prompts.map((prompt) => (
          <SamplePromptCard key={prompt} prompt={prompt} />
        ))}
        <QBox>
          <QButton
            startIcon={faChevronLeft}
            sx={{
              color: 'info.main',
              '& .MuiButton-startIcon': {
                fontSize: '12px',
              },
            }}
            variant="text"
            onClick={backToAgentBrowser}
          >
            <QText sx={{ color: 'info.main' }}>{t('button_labels.back')}</QText>
          </QButton>
        </QBox>
      </QStack>
    </TabLayout>
  );
};
